import { IPredefinedThemes, IThemeColorsModel } from '../models/event.page.model';
//  --text-section-title-color: #8b242f; need to be added for BE ???
//  auctionTextColor => --base-title-color
//  faqSectionTitleColor => --base-title-color
//  faqSectionBgColor => --base-color
//  faqSectionItemTextColor => --text-section-text-color
//  slideShowTextColor => --base-title-color
//  slideShowBgColor => no background
export const predefinedThemeNames = ['earth', 'minimal', 'ocean', 'tiffany', 'purple', 'holiday', 'empower', 'positive'];
export const earthThemeColors: IThemeColorsModel = {
  templateType: 0,
  headerType: 1,
  id: 'earth',
  url: 'paybee-spa/assets/images/png/earth.png',
  name: 'Earth Theme',
  designTemplate: 0,
  baseColorTheme: 0,
  generalColors: {
    pageBgColor: '#FFFDE1'
  },
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#FFFDE1',
  },
  headerColors: {
    navBgColor: '#FFFDE1',
    navRegularLinkColor: '#000000',
    navActiveLinkColor: '#000000',
  },
  footerColors: {
    footerTextColor: '#FFFDE1',
    footerBgColor: '#3B2924',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#000000',
    auctionBgColor: '#fffef0',
  },
  textSectionColors: {
    textSectionTextColor: '#3B2924',
    textSectionBgColor: '#96C777',
    textSectionTitleColor: '#000000',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#000000`,
    faqSectionBgColor: '#96c777',
    faqSectionItemTextColor: `#3B2924`,
    faqSectionItemTextBgColor: `#96c777`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#96C777',
    donationCampaignSectionTextColor: '#000000',
    donationCampaignButtonBgColor: '#000000',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#96C777',
    videoSectionTextColor: '#000000'
  },
  imageColors: {
    imageSectionBgColor: '#96C777',
    imageSectionTextColor: '#000000'
  },
  informationContainerColors: {
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#000000',
    informationContainerDateColor: '#000000',
    informationContainerShareIconsTextColor: '#000000',
    informationContainerBg: '#FFFDE1',
    informationContainerTextColor: '#3B2924',
    informationContainerRightTriangleBgColor: '#96C777',
  },
  slideShowColors: {
    slideShowTextColor: '#000000',
    slideShowBgColor: '#ffffff',
  }
}
export const minimalThemeColors: IThemeColorsModel = {
  templateType: 1,
  headerType: 1,
  id: 'minimal',
  name: 'Minimal Theme',
  url: 'paybee-spa/assets/images/png/minimal.png',
  designTemplate: 0,
  baseColorTheme: 1,
  generalColors: {
    pageBgColor: '#FAFAFA'
  },
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#FAFAFA',
  },
  headerColors: {
    navBgColor: '#FAFAFA',
    navRegularLinkColor: '#000000',
    navActiveLinkColor: '#363636',
  },
  footerColors: {
    footerTextColor: '#FFFFFF',
    footerBgColor: '#000000',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#000000',
    auctionBgColor: '#fefefe',
  },
  textSectionColors: {
    textSectionTextColor: '#000000',
    textSectionBgColor: '#F3F3F3',
    textSectionTitleColor: '#000000',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#000000`,
    faqSectionBgColor: '#FAFAFA',
    faqSectionItemTextColor: `#000000`,
    faqSectionItemTextBgColor: `#f3f3f3`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#FCFCFC',
    donationCampaignSectionTextColor: '#000000',
    donationCampaignButtonBgColor: '#FF0B4F',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#FCFCFC',
    videoSectionTextColor: '#000000'
  },
  imageColors: {
    imageSectionBgColor: '#FCFCFC',
    imageSectionTextColor: '#000000'
  },
  informationContainerColors: {
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#FF0B4F',
    informationContainerDateColor: '#000000',
    informationContainerShareIconsTextColor: '#FF0B4F',
    informationContainerBg: '#FAFAFA',
    informationContainerTextColor: '#000000',
    informationContainerRightTriangleBgColor: '#FCFCFC',
  },
  slideShowColors: {
    slideShowTextColor: '#000000',
    slideShowBgColor: '#FAFAFA',
  }
}
export const tiffanyThemeColors: IThemeColorsModel = {
  templateType: 2,
  headerType: 1,
  id: 'tiffany',
  name: 'Tiffany Theme',
  url: 'paybee-spa/assets/images/png/tiffany.png',
  designTemplate: 0,
  baseColorTheme: 2,
  generalColors: {
    pageBgColor: '#FAFAFA'
  },
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#FAFAFA',
  },
  headerColors: {
    navBgColor: '#BCECE0',
    navRegularLinkColor: '#4c5270',
    navActiveLinkColor: '#4C5270',
  },
  footerColors: {
    footerTextColor: '#4C5270',
    footerBgColor: '#BCECE0',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#4C5270',
    auctionBgColor: '#fcfcfc',
  },
  textSectionColors: {
    textSectionTextColor: '#000000',
    textSectionBgColor: '#BCECE0',
    textSectionTitleColor: '#000000',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#4C5270`,
    faqSectionBgColor: '#FAFAFA',
    faqSectionItemTextColor: `#000000`,
    faqSectionItemTextBgColor: `#F3F3F3`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#BCECE0',
    donationCampaignSectionTextColor: '#000000',
    donationCampaignButtonBgColor: '#4C5270',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#BCECE0',
    videoSectionTextColor: '#000000'
  },
  imageColors: {
    imageSectionBgColor: '#BCECE0',
    imageSectionTextColor: '#000000'
  },
  informationContainerColors: {
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#4C5270',
    informationContainerDateColor: '#4C5270',
    informationContainerShareIconsTextColor: '#4C5270',
    informationContainerBg: '#FAFAFA',
    informationContainerTextColor: '#000000',
    informationContainerRightTriangleBgColor: '#BCECE0',
  },
  slideShowColors: {
    slideShowTextColor: '#4C5270',
    slideShowBgColor: '#FAFAFA',
  }
}
export const holidayThemeColors: IThemeColorsModel = {
  headerType: 1,
  templateType: 3, id: 'holiday',
  name: 'Holiday Theme',
  url: 'paybee-spa/assets/images/png/holidays.png',
  designTemplate: 0,
  baseColorTheme: 3,
  generalColors: {
    pageBgColor: '#FAFAFA'
  },
  orgInfoColors: {
    orgInfoTextColor: '#144D32',
    orgInfoBgColor: '#ffffff',
  },
  headerColors: {
    navBgColor: '#144D32',
    navRegularLinkColor: '#FFFFFF',
    navActiveLinkColor: '#FFFFFF',
  },
  footerColors: {
    footerTextColor: '#9BC7A6',
    footerBgColor: '#144D32',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#144D32',
    auctionBgColor: '#ffffff',
  },
  textSectionColors: {
    textSectionTextColor: '#144D32',
    textSectionBgColor: '#9BC7A6',
    textSectionTitleColor: '#144D32',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#144D32`,
    faqSectionBgColor: '#FFFFFF',
    faqSectionItemTextColor: `#144D32`,
    faqSectionItemTextBgColor: `#9BC7A6`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#144D32',
    donationCampaignSectionTextColor: '#FFFFFF',
    donationCampaignButtonBgColor: '#E43434',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#144D32',
    videoSectionTextColor: '#ffffff'
  },
  imageColors: {
    imageSectionBgColor: '#144D32',
    imageSectionTextColor: '#ffffff'
  },
  informationContainerColors: {
    informationContainerBg: '#FFFFFF',
    informationContainerTextColor: '#144D32',
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#E43434',
    informationContainerDateColor: '#E43434',
    informationContainerShareIconsTextColor: '#E43434',
    informationContainerRightTriangleBgColor: '#144D32',
  },
  slideShowColors: {
    slideShowTextColor: '#144D32',
    slideShowBgColor: '#ffffff',
  }
}
export const oceanThemeColors: IThemeColorsModel = {
  headerType: 1,
  templateType: 4, id: 'ocean',
  name: 'Ocean Theme',
  url: 'paybee-spa/assets/images/png/ocean.png',
  designTemplate: 0,
  baseColorTheme: 4,
  generalColors: {
    pageBgColor: '#FAFAFA'
  },
  orgInfoColors: {
    orgInfoTextColor: '#012A4A',
    orgInfoBgColor: '#ffffff',
  },
  headerColors: {
    navBgColor: '#012A4A',
    navRegularLinkColor: '#FFFFFF',
    navActiveLinkColor: '#012A4A',
  },
  footerColors: {
    footerTextColor: '#9BC7A6',
    footerBgColor: '#012A4A',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#012A4A',
    auctionBgColor: '#ffffff',
  },
  textSectionColors: {
    textSectionTextColor: '#FFFFFF',
    textSectionBgColor: '#012A4A',
    textSectionTitleColor: '#FFFFFF',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#012A4A`,
    faqSectionBgColor: '#FFFFFF',
    faqSectionItemTextColor: `#FFFFFF`,
    faqSectionItemTextBgColor: `#012A4A`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#A9D6E5',
    donationCampaignSectionTextColor: '#012A4A',
    donationCampaignButtonBgColor: '#4C5270',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#A9D6E5',
    videoSectionTextColor: '#012A4A'
  },
  imageColors: {
    imageSectionBgColor: '#A9D6E5',
    imageSectionTextColor: '#012A4A'
  },
  informationContainerColors: {
    informationContainerBg: '#FFFFFF',
    informationContainerTextColor: '#012A4A',
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#4C5270',
    informationContainerDateColor: '#4C5270',
    informationContainerShareIconsTextColor: '#4C5270',
    informationContainerRightTriangleBgColor: '#A9D6E5',
  },
  slideShowColors: {
    slideShowTextColor: '#012A4A',
    slideShowBgColor: '#ffffff',
  }
}
export const purpleThemeColors: IThemeColorsModel = {
  headerType: 1,
  templateType: 5,
  id: 'purple',
  name: 'Purple Theme',
  url: 'paybee-spa/assets/images/png/ocean.png',
  designTemplate: 0,
  baseColorTheme: 5,
  generalColors: {
    pageBgColor: '#FAFAFA'
  },
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#ffffff',
  },
  headerColors: {
    navBgColor: '#330033',
    navRegularLinkColor: '#FFFFFF',
    navActiveLinkColor: '#FFFFFF',
  },
  footerColors: {
    footerTextColor: '#330033',
    footerBgColor: '#FFFF00',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#330033',
    auctionBgColor: '#ffffff',
  },
  textSectionColors: {
    textSectionTextColor: '#330033',
    textSectionBgColor: '#FFFFFF',
    textSectionTitleColor: '#330033',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#330033`,
    faqSectionBgColor: '#FFFFFF',
    faqSectionItemTextColor: `#ffffff`,
    faqSectionItemTextBgColor: `#330033`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#330033',
    donationCampaignSectionTextColor: '#FFFFFF',
    donationCampaignButtonBgColor: '#ff9933',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#330033',
    videoSectionTextColor: '#ffffff'
  },
  imageColors: {
    imageSectionBgColor: '#330033',
    imageSectionTextColor: '#ffffff'
  },
  informationContainerColors: {
    informationContainerBg: '#FFFFFF',
    informationContainerTextColor: '#000000',
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#ff9933',
    informationContainerDateColor: '#330033',
    informationContainerShareIconsTextColor: '#ffffff',
    informationContainerRightTriangleBgColor: '#330033',
  },
  slideShowColors: {
    slideShowTextColor: '#330033',
    slideShowBgColor: '#ffffff',
  }
}
export const positiveThemeColors: IThemeColorsModel = {
  headerType: 1,
  templateType: 6,
  id: 'positive',
  name: 'Positive Theme',
  url: 'paybee-spa/assets/images/png/ocean.png',
  designTemplate: 0,
  baseColorTheme: 6,
  generalColors: {
    pageBgColor: '#FFFFFF'
  },
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#ffffff',
  },
  headerColors: {
    navBgColor: '#ffffff',
    navRegularLinkColor: '#000000',
    navActiveLinkColor: '#7f7f7f',
  },
  footerColors: {
    footerTextColor: '#ffffff',
    footerBgColor: '#000000',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#000000',
    auctionBgColor: '#ffffff',
  },
  textSectionColors: {
    textSectionTextColor: '#000000',
    textSectionBgColor: '#ffffff',
    textSectionTitleColor: '#8b242f',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#000000`,
    faqSectionBgColor: '#FFFFFF',
    faqSectionItemTextColor: `#000000`,
    faqSectionItemTextBgColor: `#F0F0F0`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#000000',
    donationCampaignSectionTextColor: '#ffffff',
    donationCampaignButtonBgColor: '#FF9A00',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#000000',
    videoSectionTextColor: '#ffffff'
  },
  imageColors: {
    imageSectionBgColor: '#000000',
    imageSectionTextColor: '#ffffff'
  },
  informationContainerColors: {
    informationContainerBg: '#FFFFFF',
    informationContainerTextColor: '#000000',
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#FF9A00',
    informationContainerDateColor: '#000000',
    informationContainerShareIconsTextColor: '#ffffff',
    informationContainerRightTriangleBgColor: '#000000',
  },
  slideShowColors: {
    slideShowTextColor: '#000000',
    slideShowBgColor: '#ffffff',
  }
}
export const empowerThemeColors: IThemeColorsModel = {
  headerType: 1,
  templateType: 7,
  id: 'empower',
  name: 'Empower Theme',
  url: 'paybee-spa/assets/images/png/ocean.png',
  designTemplate: 0,
  baseColorTheme: 7,
  generalColors: {
    pageBgColor: '#FFFFFF'
  },
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#ffffff',
  },
  headerColors: {
    navBgColor: '#ffffff',
    navRegularLinkColor: '#000000',
    navActiveLinkColor: '#7f7f7f',
  },
  footerColors: {
    footerTextColor: '#ffffff',
    footerBgColor: '#A8504D',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#000000',
    auctionBgColor: '#ffffff',
  },
  textSectionColors: {
    textSectionTextColor: '#000000',
    textSectionBgColor: '#EFA940',
    textSectionTitleColor: '#ffffff',
  },
  fAQSectionColors: {
    faqSectionTitleColor: `#000000`,
    faqSectionBgColor: '#FFFFFF',
    faqSectionItemTextColor: `#000000`,
    faqSectionItemTextBgColor: `#F0F0F0`
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#A8504D',
    donationCampaignSectionTextColor: '#ffffff',
    donationCampaignButtonBgColor: '#D03953',
    donationCampaignButtonTextColor: '#FFFFFF',
  },
  videoColors: {
    videoSectionBgColor: '#A8504D',
    videoSectionTextColor: '#ffffff'
  },
  imageColors: {
    imageSectionBgColor: '#A8504D',
    imageSectionTextColor: '#ffffff'
  },
  informationContainerColors: {
    informationContainerBg: '#FFFFFF',
    informationContainerTextColor: '#000000',
    informationContainerButtonTextColor: '#FFFFFF',
    informationContainerButtonBgColor: '#D03953',
    informationContainerDateColor: '#000000',
    informationContainerShareIconsTextColor: '#ffffff',
    informationContainerRightTriangleBgColor: '#A8504D',
  },
  slideShowColors: {
    slideShowTextColor: '#000000',
    slideShowBgColor: '#ffffff',
  }
}

export const predefinedThemeColors: IPredefinedThemes = {
  earth: earthThemeColors,
  minimal: minimalThemeColors,
  tiffany: tiffanyThemeColors,
  holiday: holidayThemeColors,
  ocean: oceanThemeColors,
  purple: purpleThemeColors,
  positive: positiveThemeColors,
  empower: empowerThemeColors
}

export const defaultThemeColors: IThemeColorsModel = {
  name: 'New Theme',
  headerType: 1,
  designTemplate: 0,
  baseColorTheme: 10,
  orgInfoColors: {
    orgInfoTextColor: '#000000',
    orgInfoBgColor: '#ffffff',
  },
  generalColors: {
    pageBgColor: '#FFFFFF'
  },
  headerColors: {
    navBgColor: '#ffffff',
    navRegularLinkColor: '#000000',
    navActiveLinkColor: '#000000',
  },
  footerColors: {
    footerTextColor: '#ffffff',
    footerBgColor: '#A8504D',
  },
  sponsorsColors: {
    sponsorsTitleColor: '#ffffff',
    sponsorsTextColor: '#828282',
    sponsorsBgColor: '#000000',
  },
  customThemeAuctionColors: {
    auctionTextColor: '#000000',
    auctionBgColor: '#ffffff',
  },
  textSectionColors: {
    textSectionTextColor: '#000000',
    textSectionBgColor: '#ffffff',
    textSectionTitleColor: '#000000',
  },
  fAQSectionColors: {
    faqSectionTitleColor: '#000000',
    faqSectionBgColor: '#ffffff',
    faqSectionItemTextColor: '#000000',
    faqSectionItemTextBgColor: '#eeeeee',
  },
  campaignSectionColors: {
    donationCampaignSectionBgColor: '#ffffff',
    donationCampaignSectionTextColor: '#000000',
    donationCampaignButtonBgColor: '#eeeeee',
    donationCampaignButtonTextColor: '#000000',
  },
  videoColors: {
    videoSectionBgColor: '#ffffff',
    videoSectionTextColor: '#000000',
  },
  imageColors: {
    imageSectionBgColor: '#ffffff',
    imageSectionTextColor: '#000000'
  },
  informationContainerColors: {
    informationContainerBg: '#FFFFFF',
    informationContainerTextColor: '#000000',
    informationContainerButtonTextColor: '#000000',
    informationContainerButtonBgColor: '#eeeeee',
    informationContainerDateColor: '#000000',
    informationContainerShareIconsTextColor: '#000000',
    informationContainerRightTriangleBgColor: '#ffffff',
  },
  slideShowColors: {
    slideShowTextColor: '#000000',
    slideShowBgColor: '#ffffff',
  }
}

export const allHeaderTypes: {id: number, name: string }[] = [
  { id: 1, name: 'Default - Image In The Background' },
  { id: 2, name: 'Postcard - Image On The Left'},
  { id: 3, name: 'Business Card - Image On The Right'},
  { id: 4, name: 'Minimal - Smaller Image On The Right (Description Off Screen)'},
  { id: 5, name: 'Flyer - Image Below (Description Off Screen)'}
]
